import { defineMessages } from "react-intl";

// Username + admin-set password, for staff (ops operators) without a mailbox.
export const staffSignInMessages = defineMessages({
  opsSignIn: {
    id: "Yjd7Ag",
    defaultMessage: "Ops sign-in",
    description: "staff section header",
  },
  inviteHint: {
    id: "ikpcVI",
    defaultMessage:
      "For people without an email: give them a username and a password and they sign in to ops with it. The email can stay empty. With a password set, no invite email is sent.",
    description: "staff invite dialog hint",
  },
  detailsHint: {
    id: "NTq14u",
    defaultMessage:
      "The username works on the ops sign-in instead of the email. Type a new password to replace theirs; this signs them out everywhere. Leave it empty to keep it.",
    description: "staff details card hint",
  },
  username: {
    id: "PPd3cy",
    defaultMessage: "Username",
    description: "staff username input label",
  },
  password: {
    id: "0WnCaV",
    defaultMessage: "Password",
    description: "staff password input label",
  },
  newPassword: {
    id: "UPqYzR",
    defaultMessage: "New password",
    description: "staff new password input label",
  },
  createAccount: {
    id: "FfMebB",
    defaultMessage: "Create account",
    description: "staff invite dialog button when a password is set",
  },
});
